module.exports = __webpack_public_path__ + "static/media/eia.12cf79c2.png";